import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AnalyticsConsent from "@/components/AnalyticsConsent";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-ink-900">
      <a href="#main-content" className="fixed left-3 top-3 z-[200] -translate-y-24 bg-white px-4 py-3 font-semibold text-ink-900 shadow-xl transition-transform focus:translate-y-0">Skip to main content</a>
      <Navigation />
      <main id="main-content" className="flex-1" tabIndex="-1">{children}</main>
      <Footer />
      <AnalyticsConsent />
    </div>
  );
}
